import { ApiError } from "./client";

const messages: Record<string, string> = {
  invalid_request: "提交内容不符合要求，请检查表单。",
  invalid_limit: "请求数量必须在 1 到 1000 之间。",
  unauthorized: "Operator Session 已失效，请重新登录。",
  origin_mismatch: "浏览器 Origin 与 Gateway 配置不一致，请检查部署配置。",
  not_found: "目标对象已不存在，列表将重新加载。",
  unknown_route: "Admin API 路径不匹配，请检查前后端版本。",
  method_not_allowed: "Admin API 方法不匹配，请检查前后端版本。",
  conflict: "对象状态已发生变化，请刷新后重试。",
  internal_error: "Gateway 处理失败。",
  relay_unavailable: "Relay 暂不可达。",
  relay_quota_unavailable: "Relay 配额暂不可用。",
  relay_quota_invalid: "Relay 返回了无效的配额数据。",
  relay_status_unavailable: "Relay 状态暂不可用。",
  relay_status_invalid: "Relay 返回了无效的状态数据。",
  network_error: "无法连接 Gateway。",
  invalid_response: "Gateway 返回内容与当前 UI 契约不匹配。",
  unexpected_error: "Gateway 返回了无法识别的错误。",
};

export function errorMessage(error: unknown): string {
  if (!(error instanceof ApiError)) return "发生未知错误。";
  const message = messages[error.code] ?? "操作失败。";
  const suffix = error.code ? `（${error.code}）` : "";
  if (error.mutationOutcomeUnknown) {
    return `请求结果未知，请先刷新确认，系统不会自动重试。${suffix}`;
  }
  return `${message}${suffix}`;
}

export function isRefreshRequired(error: unknown): boolean {
  return (
    error instanceof ApiError &&
    (error.code === "not_found" || error.code === "conflict" || error.mutationOutcomeUnknown)
  );
}
